import React from "react";
import { Button } from "@/components/ui/button";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH.
// Emergent-managed Google OAuth: send the user to auth.emergentagent.com with a redirect back to
// this app's /auth/callback route. The redirect origin is derived dynamically from window.location
// so the same code works on preview + production without config edits.
export default function GoogleLoginButton({ label = "Continue with Google", className = "" }) {
  const go = () => {
    const redirect = `${window.location.origin}/auth/callback`;
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirect)}`;
  };
  return (
    <Button
      data-testid="google-login-btn"
      type="button"
      variant="outline"
      onClick={go}
      className={`w-full h-12 rounded-full bg-white border-2 border-slate-300 hover:border-orange-800 hover:bg-orange-50 text-slate-800 font-semibold gap-3 active:scale-95 transition-transform ${className}`}
    >
      <svg width="18" height="18" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg" aria-hidden>
        <path fill="#EA4335" d="M24 9.5c3.9 0 6.6 1.7 8.1 3.1l6-5.8C34.5 3.2 29.7 1 24 1 14.9 1 7.1 6.2 3.4 13.7l7 5.4C12.3 13.1 17.6 9.5 24 9.5z"/>
        <path fill="#4285F4" d="M46.5 24.5c0-1.6-.1-3.2-.4-4.7H24v9h12.7c-.5 2.9-2.1 5.4-4.6 7l7.1 5.5c4.2-3.9 6.6-9.6 6.6-16.8z"/>
        <path fill="#FBBC05" d="M10.4 28.9c-.5-1.4-.7-2.9-.7-4.4 0-1.5.3-3 .7-4.4l-7-5.4C1.9 17.9 1 20.8 1 24s.9 6.1 2.4 9l7-4.1z"/>
        <path fill="#34A853" d="M24 47c6.5 0 11.9-2.1 15.9-5.9l-7.1-5.5c-2 1.4-4.6 2.2-8.8 2.2-6.4 0-11.7-3.6-13.6-8.9l-7 5.4C7.1 41.8 14.9 47 24 47z"/>
        <path fill="none" d="M0 0h48v48H0z"/>
      </svg>
      {label}
    </Button>
  );
}
